import React, { useEffect } from 'react';

import styles from './AdultFeedingItem.module.scss';
import Checkbox from '../../../../../components/Checkbox';
import Input from '../../../../../components/Input';
import { InputType } from '../../../../../utils/@globalTypes';
import { FormikProps, useFormikContext } from 'formik';
import { FEEDING_ADULT_REQ, priceMask } from '../../../../../utils/constants';
import Tooltip from '../../../../../components/Tooltip';
import { FeedingSettingsType } from '../../../../../redux/types/mainObjectTypes';

type AdultFeedingItemProps = {
  title: string;
  field: string;
};

const AdultFeedingItem = ({ title, field }: AdultFeedingItemProps) => {
  const {
    setFieldValue,
    values,
    errors,
    touched,
    validateField,
    setFieldTouched,
    handleChange,
    dirty,
    resetForm,
  } = useFormikContext<any>();
  const label = `has_${field}`;
  // console.log(values.kids)
  useEffect(() => {
    if (!values[label] && values[field]) {
      setFieldValue(field, '');
    }
  }, [values[label], values[field]]);

  useEffect(() => {
    if (touched[field]) {
      validateField(field);
    }
  }, [touched, values]);
  useEffect(() => {
    if (Object.keys(touched).length === 0) {
      resetForm();
    }
  }, []);

  priceMask.max = 99999.99;
  priceMask.min = 0.0;

  return (
    <div className={styles.itemContainer}>
      <div className={styles.itemLine}>
        <span className={styles.checkbox}>
          <Checkbox
            checked={values[label]}
            label={title}
            name={label}
            onClick={() => {
              setFieldValue(label, !values[label]);
            }}
          />
        </span>
        {values[label] && (
          <Tooltip
            requirementsText={FEEDING_ADULT_REQ}
            error={!!errors[field]}
          />
        )}
      </div>
      {values[label] && (
        <div className={styles.price}>
          <div className={styles.input}>
            <Input
              id={field}
              placeholder="Введите цену"
              type={InputType.MASK}
              mask={priceMask}
              value={values[field]}
              onChange={handleChange(field)}
              errText={errors[field]?.toString()}
              onBlur={() => setFieldTouched(field)}
            />
          </div>
          <span>BYN </span>         
        </div>
      )}
    </div>
  );
};

export default AdultFeedingItem;
